export default class Swiper {
	constructor(content, leftCallback, rigthCallback) {
		this.handleSwipe(content, leftCallback, rigthCallback)
	}

	handleSwipe(content, leftCallback, rightCallback, swipeEvent = true) {
		if (content) {
			let startX;

			if (!content.dataset.swipeEventAdded) {
				content.addEventListener('touchstart', (e) => {
					startX = e.touches[0].clientX;
				});

				content.addEventListener('touchend', (e) => {
					const endX = e.changedTouches[0].clientX;
					const diffX = endX - startX;

					if (Math.abs(diffX) > 150) {
						if (diffX > 0) {
							leftCallback();
						} else {
							rightCallback();
						}
					}
				});
			}

			content.dataset.swipeEventAdded = swipeEvent;
		}
	}
}
